import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useEffect } from 'react';

interface Params {
    message: string;
}

const IdentifyFailActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { message } = params;
  const toast = useToast();
  const { replace } = useFlow();
  useEffect(() => {
    toast.error(message || '본인인증에 실패하였습니다.');
    replace('MainActivity', {}, { animate: false });
  }, [message]);
  return (
        <AppScreen>
            <div></div>
        </AppScreen>
  );
};

export default IdentifyFailActivity;
